export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(miningId: number): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}

export const PROVIDERS = {
  ADSGRAM: 'adsgram',
  BARZHA: 'barzha',
  TADS: 'tads',
  FLYER: 'flyer',
  TAPPADS: 'tappads',
  ONCLICK: 'onclick',
  ADEXTRA: 'adextra',
  RICHADS: 'richads',
  MONETAG: 'monetag',
  ADEXIUM: 'adexium',
} as const;

interface AdextraSDK {
  p_adextra: (
    onSuccess: () => void,
    onError: () => void,
    placementId?: string,
  ) => void;
}

declare global {
  interface Window {
    p_adextra?: AdextraSDK['p_adextra'];
  }
}

export class AdextraBoostProvider implements BoostProvider {
  private static AD_PLACEMENT_ID = '6d01981a0cbc7e700ec4baa4e2045e01c1b95386';
  private isInitialized = false;
  private initializationPromise: Promise<void> | null = null;

  getName(): string {
    return PROVIDERS.ADEXTRA;
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    console.log('GOOo');
    try {
      await this.initialize();

      if (this.isInitialized) {
        return [
          {
            id: 'adextra-1',
            title: 'Просмотреть рекламу',
            description: 'Посмотрите рекламу для получения буста',
            provider: this.getName(),
            onClick: async () => {
              return await this.showAd();
            },
          },
        ];
      }

      return [];
    } catch (error) {
      return [];
    }
  }

  private async initialize(): Promise<void> {
    if (this.isInitialized) return;

    if (this.initializationPromise) {
      return this.initializationPromise;
    }

    try {
      this.initializationPromise = (async () => {
        await this.waitForSDK();
        this.ensureAdContainerExists();
        this.isInitialized = true;
      })();

      await this.initializationPromise;
    } catch (error) {
      this.isInitialized = false;
      throw error;
    } finally {
      this.initializationPromise = null;
    }
  }

  private ensureAdContainerExists(): void {
    let container = document.getElementById(
      AdextraBoostProvider.AD_PLACEMENT_ID,
    );
    if (!container) {
      container = document.createElement('div');
      container.id = AdextraBoostProvider.AD_PLACEMENT_ID;
      document.body.appendChild(container);
    }
  }

  private waitForSDK(timeout = 5000): Promise<void> {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const check = () => {
        if (typeof window.p_adextra === 'function') {
          resolve();
        } else if (Date.now() - start > timeout) {
          reject(new Error('Таймаут ожидания загрузки Adextra SDK'));
        } else {
          setTimeout(check, 100);
        }
      };

      check();
    });
  }

  async startTask(): Promise<'success' | 'user_cancelled' | 'ads_not_found'> {
    return this.showAd();
  }

  private async showAd(): Promise<
    'success' | 'user_cancelled' | 'ads_not_found'
  > {
    try {
      const p_adextra = window.p_adextra;
      if (typeof p_adextra !== 'function') {
        return 'ads_not_found';
      }

      this.ensureAdContainerExists();
      const adContainer = document.getElementById(
        AdextraBoostProvider.AD_PLACEMENT_ID,
      );
      if (!adContainer) {
        return 'ads_not_found';
      }

      return new Promise((resolve) => {
        const onSuccess = () => {
          resolve('success');
        };

        const onError = () => {
          resolve('ads_not_found');
        };

        p_adextra(onSuccess, onError, AdextraBoostProvider.AD_PLACEMENT_ID);
      });
    } catch (error) {
      return 'ads_not_found';
    }
  }
}
